import ServiceBase from './ServiceBase'
import type {
  ContentSubmissionPayload,
  SubmissionResult,
  SubmissionListResult,
  EligibilityResult,
} from '@/types/travelExplorer'

class TravelExplorerService extends ServiceBase {
  getShareJourneyStatus(): Promise<{ success: boolean; data: { enabled: number } }> {
    return new Promise((resolve, reject) => {
      this.webGet(
        {},
        (data: { success: boolean; data: { enabled: number } }) => resolve(data),
        'api/content_submission/featureStatus',
        (err: any) => reject(err),
      )
    })
  }

  submitContent(payload: ContentSubmissionPayload): Promise<SubmissionResult> {
    return new Promise((resolve, reject) => {
      this.webPost(
        payload,
        (data: SubmissionResult) => resolve(data),
        'api/content_submission',
        (err: any) => reject(err),
      )
    })
  }

  getMySubmissions(params: { page?: number; date_from?: string; date_to?: string; status?: 0 | 1 | 2 } = {}): Promise<SubmissionListResult> {
    return new Promise((resolve, reject) => {
      this.webGet(
        params,
        (data: SubmissionListResult) => resolve(data),
        'api/content_submission/list',
        (err: any) => reject(err),
      )
    })
  }

  getPointsEligibility(productId: number, departDate: string): Promise<EligibilityResult> {
    return new Promise((resolve, reject) => {
      this.webGet(
        { product_id: productId, depart_date: departDate },
        (data: EligibilityResult) => resolve(data),
        'api/reward/eligibility',
        (err: any) => reject(err),
      )
    })
  }

  getPointsBalance(): Promise<{ points: number }> {
    return new Promise((resolve, reject) => {
      this.webGet(
        {},
        (data: { points: number }) => resolve(data),
        'api/reward/available',
        (err: any) => reject(err),
      )
    })
  }
}

export default new TravelExplorerService()
